import React, { createContext, useReducer } from 'react'

export type IConfirmation = {
  // ReactNode so callers can style parts of the message (e.g. the Shopify store-switch
  // prompt colors the store names); plain strings still work everywhere.
  message: React.ReactNode
  // Label for the confirm button; defaults to "Confirm" (e.g. "Switch store").
  confirmLabel?: string
  onConfirm: null | (() => void)
  onCancel: null | (() => void)
}

export type IConfirmationState = IConfirmation & {
  visible: boolean
}

const makeInitialState = (): IConfirmationState => {
  return {
    message: '',
    confirmLabel: undefined,
    visible: false,
    onConfirm: null,
    onCancel: null,
  }
}

export const ConfirmationContext = createContext({} as any)

type ConfirmationAction =
  | { type: 'show'; payload: IConfirmation }
  | { type: 'closed' }

const reducer = (
  state: IConfirmationState,
  action: ConfirmationAction
): IConfirmationState => {
  switch (action.type) {
    case 'show':
      return {
        message: action.payload.message,
        confirmLabel: action.payload.confirmLabel,
        visible: true,
        onConfirm: action.payload.onConfirm,
        onCancel: action.payload.onCancel,
      }
    case 'closed':
      return { ...state, visible: false }
  }
}

const ConfirmationContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, makeInitialState())

  return (
    <ConfirmationContext.Provider value={[state, dispatch]}>
      {children}
    </ConfirmationContext.Provider>
  )
}

export default ConfirmationContextProvider
